import { createRouter, createWebHistory } from 'vue-router'
import ExplorerView from "@/views/ExplorerView.vue";

const routes = [
  {
    path: '/',
    name: 'home',
    component: ExplorerView
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
